export default {"src":"/_next/static/media/Nginx.798737e0.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};